import { Grid } from '@material-ui/core';
import { ModalWithButtons } from '../../components/ModalWithButtons/ModalWithButtons.component';
import SolutionCard from './SolutionCard.component';

interface SolutionCardModalProps {
  onClose: () => void;
  cardId: string;
}

export const SolutionCardModal: React.FC<SolutionCardModalProps> = ({ onClose, cardId }) => {
  const modalStyle = {
    width: '90%',
    height: '90%',
    left: '5%',
    top: '5%',
  };

  return (
    <>
      <ModalWithButtons
        xCloseButton={onClose}
        open={true}
        title={''}
        fullScreen
        isPageInModal
        pageContainerStyle={modalStyle}
        isHideBackdrop={false}
      >
        <Grid>
          <Grid item xs={12}>
            <SolutionCard cardId={cardId} />
          </Grid>
        </Grid>
      </ModalWithButtons>
    </>
  );
};
